/**
 * @file 給与の変更を監視
 */
'use strict'

/**
 * @classname ChangeSalaryType
 * @classdesc 給与の変更を監視
 */
export default class ChangeSalaryType {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.input-select-salary-type')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$descriptionAllowances = $('.input-text-description-of-allowances')
		this._$e.on('change', () => this.onChange())
	}

	/**
	 * onChangeのコールバック
	 *
	 * @memberof ChangeSalaryType
	 * @description 時給の場合は「法定時間外手当、深夜手当、法定休日勤務手当あり」と自動表記で編集不可、日給、月給の場合は「法定時間外手当、深夜手当、法定休日勤務手当あり」で表記し編集可能に
	 * @return {undefined}
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`)
		const terms = '法定時間外手当、深夜手当、法定休日勤務手当あり'
		const className = this._$e.find('option:selected').attr('class')
		if (className === 'salary-hourly') {
			console.log('時給 が選択')
			this._$descriptionAllowances.val(terms)
			this._$descriptionAllowances.prop('readonly', true)
		} else {
			this._$descriptionAllowances.prop('readonly', false)
			if (className === 'salary-month' || className === 'salary-date') {
				console.log('日給、月給 が選択')
				if(this._$descriptionAllowances.val() === ''){
					this._$descriptionAllowances.val(terms)
				}
			} else {
				this._$descriptionAllowances.val('')
			}
		}
	}
}
